import React, { useEffect, useState } from "react";
import functions from "../util/functions";
import ajaxUser from "../util/remote/ajaxUser";
import { getCompany, onCompanyChange } from "../util/accounting/company";

const AuthContext = React.createContext();

export const AuthConsumer = AuthContext.Consumer;

export const AuthProvider = (props) => {
  const userId = functions.sessionGuard();
  const [permissionLists, setPermissionList] = useState([]);
  const [user, setUser] = useState(false);
  // Which company's books are open, so anything shaped by the company — the
  // dashboard layout, the reporting currency — follows a switch immediately.
  const [company, setCompanyState] = useState(getCompany);

  useEffect(() => {
    getUserAccess();
    getUserInfo();
  }, [userId]);

  useEffect(() => onCompanyChange(() => setCompanyState(getCompany())), []);

  const getUserAccess = async () => {
    if (!userId) {
      return false;
    }
    const server_response = await ajaxUser.getUserPermissionCodes(userId);

    if (server_response.status === "OK") {
      setPermissionList(server_response.details);
    } else {
      // alert("Something went wrong loading YEXP, check your connection or contact system admin")
    }
  };

  const getUserInfo = async () => {
    const server_response = await ajaxUser.fetchSingleUser(userId);

    if (server_response.status === "OK") {
      setUser(server_response.details);
    } else {
      // alert("Something went wrong loading YEXP, check your connection or contact system admin")
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        userId,
        permissionLists,
        getUserInfo,
        getUserAccess,
        // The open company, for anything that has to name it — page headers,
        // report letterheads, the sidebar.
        company,
        // The accounting module shapes its dashboard, menu and seeded chart of
        // accounts around the kind of organisation it is running for — and this
        // system keeps the books of more than one. So it follows whichever
        // company is currently open: a contractor gets the services layout, the
        // farm it also owns gets its own. Outside accounting nothing reads it,
        // and with no company open the safe general profile applies.
        industry: company?.industry || "services",
      }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
